'use-client';
import * as React from 'react';
import type { ImpressProps, ImpressImperativeActions } from '../Impress.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Impress: React.ForwardRefRenderFunction<
  ImpressImperativeActions,
  ImpressProps
> = (props, forwardRef) => {
  return <TPAGallery {...props} forwardRef={forwardRef}></TPAGallery>;
};

export default React.forwardRef(Impress);
